import { render, staticRenderFns } from "./areasIndex.vue?vue&type=template&id=1d232669&scoped=true"
import script from "./areasIndex.vue?vue&type=script&lang=js"
export * from "./areasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d232669",
  null
  
)

export default component.exports